export function dayofmonthCheck(value, manipulatedDate) {
    //Check dayofmonth field
    if (value.dayofmonth === "*" || value.dayofmonth === "?") {
        return true;
    }
    if (typeof value.DELIMITER_DOM !== "undefined") {
        //Day is start and interval
        const dayofmontharr = value.dayofmonth
            .split(value.DELIMITER_DOM)
            .map((entry) => (entry === "*" ? entry : parseInt(entry)));
        const dayofmonthisincluded = dayofmontharr.includes(manipulatedDate.date()) ||
            dayofmontharr[0] === "*";
        if (value.DELIMITER_DOM === "/") {
            // dayofmonth is start and interval
            if ((dayofmontharr[0] === "*" ? 1 : parseInt(dayofmontharr[0])) >
                manipulatedDate.daysInMonth()) {
                return false;
            }
            // Normalize to number of days in month cycle
            const offset = (manipulatedDate.date() -
                (dayofmontharr[0] === "*" ? 1 : parseInt(dayofmontharr[0])) +
                manipulatedDate.daysInMonth()) %
                manipulatedDate.daysInMonth();
            // Check divisibility
            return offset % parseInt(dayofmontharr[1]) === 0;
        }
        //Day is comma separated list
        if (value.DELIMITER_DOM === "," && dayofmonthisincluded) {
            return true;
        }
        //Day is a single day
        if (manipulatedDate.date() === dayofmontharr[0]) {
            return true;
        }
    }
    return false;
}
//# sourceMappingURL=dayofmonthCheck.js.map